export default __webpack_public_path__ + "fonts/nunito-v25-latin-700.woff2";